(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('kendo.charts.cmn.chunk.js'), require('kendo.drawing.js')) :
    typeof define === 'function' && define.amd ? define(['exports', 'kendo.charts.cmn.chunk', 'kendo.drawing'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.kendo = global.kendo || {}, global.kendo._globals = global.kendo._globals || {}, global.kendo._globals.DatavizCore = {}), global.kendo._globals.ChartsCmnChunk));
})(this, (function (exports, kendo_charts_cmn_chunk_js) {
    const __meta__ = {
        id: "dataviz.core",
        name: "Core",
        description: "The DataViz core functions",
        category: "dataviz",
        depends: ["core", "drawing", "charts.cmn.chunk"],
        hidden: true
    };


    window.kendo.dataviz = window.kendo.dataviz || {};

    kendo.deepExtend(kendo.dataviz, kendo.deepExtend({}, kendo_charts_cmn_chunk_js.c));
    kendo.dataviz.Gradients = kendo_charts_cmn_chunk_js.G;

    const $ = kendo.jQuery;
    let dataviz = kendo.dataviz;
    let draw = kendo.drawing;
    let services = kendo_charts_cmn_chunk_js.s;

    for (let member in kendo_charts_cmn_chunk_js.c) {
        if (kendo_charts_cmn_chunk_js.h(member)) {
            dataviz[member] = kendo_charts_cmn_chunk_js.c[member];
        }
    }

    dataviz.SASS_THEMES = ["sass", "default-v2", "bootstrap-v4", "material-v2"];

    dataviz.ExportMixin = {
        extend: function(proto, skipLegacy) {
            if (!proto.exportVisual) {
                throw new Error("Mixin target has no exportVisual method defined.");
            }

            proto.exportSVG = this.exportSVG;
            proto.exportImage = this.exportImage;
            proto.exportPDF = this.exportPDF;

            if (!skipLegacy) {
                proto.svg = this.svg;
                proto.imageDataURL = this.imageDataURL;
            }
        },

        exportSVG: function(options) {
            return draw.exportSVG(this.exportVisual(), options);
        },

        exportImage: function(options) {
            return draw.exportImage(this.exportVisual(options), options);
        },

        exportPDF: function(options) {
            return draw.exportPDF(this.exportVisual(), options);
        },

        svg: function() {
            if (draw.svg.Surface) {
                return draw.svg.exportGroup(this.exportVisual());
            } else {
                throw new Error("SVG Export failed. Unable to export instantiate kendo.drawing.svg.Surface");
            }
        },

        imageDataURL: function() {
            if (!kendo.support.canvas) {
                return null;
            }

            if (draw.canvas.Surface) {
                var container = $("<div />").css({
                    display: "none",
                    width: this.element.width(),
                    height: this.element.height()
                }).appendTo(document.body);

                var surface = new draw.canvas.Surface(container[0]);
                surface.draw(this.exportVisual());
                var image = surface._rootElement.toDataURL();

                surface.destroy();
                container.remove();

                return image;
            } else {
                throw new Error("Image Export failed. Unable to export instantiate kendo.drawing.canvas.Surface");
            }
        }
    };

    services.IntlService.register({
        format: function(format) {
            return kendo.format.apply(null, [format].concat(Array.prototype.slice.call(arguments, 1)));
        },
        toString: kendo.toString,
        parseDate: kendo.parseDate,
        firstDay: function() {
            return kendo.culture().calendars.standard.firstDay;
        }
    });

    services.TemplateService.register({
        compile: kendo.template
    });
    dataviz.inArray = function(value, array) {
        if (array) {
            return array.indexOf(value) !== -1;
        }
    };
    dataviz.Point2D = kendo_charts_cmn_chunk_js.P;
    dataviz.Box2D = kendo_charts_cmn_chunk_js.B;
    dataviz.mwDelta = function(e) {
        return kendo_charts_cmn_chunk_js.m(e.originalEvent);
    };


    var kendo$1 = kendo;

    exports.__meta__ = __meta__;
    exports.default = kendo$1;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
